import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class Placeholder extends BaseOption {
  static userInterfaceComponent = {
    label: "Placeholder",
    component: inspectorTools.SIMPLE_INPUT,
  };

  static defaultValue = "Type here...";
}
